import axios from 'axios';
import { genericFilePost, genericGet, genericPost } from './apiService';
import { API_KEY, API_URL } from '../config/env';
import { decrypt } from '../utils/crypto';

/**
 * Kiracı portalı (sözleşme v2 §B) — `api/TenantPortal/...`
 * Kiracı da Odazen kullanıcısıdır; davet önizlemesi dışındaki uçlar oturum ister.
 * Fonksiyonlar apiService yanıtını döner: { success, statusCode, data, message } (hatalar orada toast olarak gösterilir).
 * `silent*` sürümleri toast göstermez ve oturum süresi dolduğunda yönlendirmez (önizleme sayfası ve menüdeki tembel kontrol).
 */
const BASE = `${API_URL}TenantPortal/`;
const LANG = { tr: '1', en: '2' };

const silentHeaders = () => {
  const lng = (typeof localStorage !== 'undefined' && localStorage.getItem('i18nextLng')) || 'tr';
  const h = { accept: 'application/json', 'x-root': API_KEY, ChannelId: '1', lang: LANG[lng] || '1', language: lng };
  try {
    const enc = localStorage.getItem('authToken');
    const token = enc ? decrypt(enc) : null;
    if (token && typeof token === 'string') h.Authorization = `Bearer ${token}`;
  } catch {
    /* geçersiz token: girişsiz istek */
  }
  return h;
};

/** Toast'sız GET: { success, statusCode, data, message } */
const silentGet = async (url, params) => {
  try {
    const res = await axios.get(url, { params, headers: silentHeaders(), validateStatus: () => true });
    const body = res.data && typeof res.data === 'object' ? res.data : {};
    const code = res.status !== 200 ? res.status : Number(body.statusCode) || 200;
    return { success: code === 200, statusCode: code, data: code === 200 ? body.data ?? null : null, message: body.message || null };
  } catch {
    return { success: false, statusCode: 0, data: null, message: null };
  }
};

/** Girişsiz davet önizlemesi (adres yok; yalnızca x-root) — 404/409/410/429 sayfada açıklanır, toast yok */
export const previewInvite = (code) => silentGet(`${BASE}invite/${encodeURIComponent(code)}`);
/** Daveti kabul et (giriş gerekli) → { tenancyId } */
export const acceptInvite = (code) => genericPost(`${BASE}invite/${encodeURIComponent(code)}/accept`);

export const getMyTenancies = () => genericGet(`${BASE}tenancies`);
/** Menüdeki "Kiracı paneli" girişi için sessiz kontrol */
export const silentMyTenancies = () => silentGet(`${BASE}tenancies`);
export const getMyTenancy = (id) => genericGet(`${BASE}tenancies/${encodeURIComponent(id)}`);

/** Dekont yükleme (multipart: file pdf/jpg/png ≤ 10 MB, note?) */
export const uploadReceipt = (paymentId, file, note) => {
  const fd = new FormData();
  fd.append('file', file);
  if (note) fd.append('note', note);
  return genericFilePost(`${BASE}payments/${encodeURIComponent(paymentId)}/receipts`, fd);
};
/** Yalnızca kendi yüklediği dekont → { url, expiresAt } */
export const getMyReceiptLink = (receiptId) => genericGet(`${BASE}receipts/${encodeURIComponent(receiptId)}/link`);

export const getTenantMessages = (tenancyId, { before, take } = {}) => {
  const params = {};
  if (before) params.before = before;
  if (take) params.take = take;
  return genericGet(`${BASE}tenancies/${encodeURIComponent(tenancyId)}/messages`, params);
};
/** Sözleşme v2.1: gövde { messageText } (1–2000 karakter) */
export const sendTenantMessage = (tenancyId, messageText) => genericPost(`${BASE}tenancies/${encodeURIComponent(tenancyId)}/messages`, { messageText });

/** Kiracı bağlantıyı kendisi kaldırır */
export const leaveTenancy = (tenancyId) => genericPost(`${BASE}tenancies/${encodeURIComponent(tenancyId)}/leave`);
